<div class="dialog-wrappers assign-ticket-to-dialog">
    <div class="display-flex padding-dialog dialog-header">
        <div class="float-left">
            <div class="dialog-header-title">
                <h1>Assign To</h1>
            </div>
        </div>
        <div class="float-right">
            <span class="close-dialog" (click)="onCancel()"><img src="../../../assets/icons/icon-close-red.svg"
                    alt="Close" width="32" height="32" /></span>
        </div>
    </div>
    <mat-dialog-content>
        <div class="padding-dialog">
            <div class="search-wrap">
                <app-search-field [formControl]="searchControl" placeholder="Search team..."></app-search-field>
            </div>
            <div class="table-wrap">
                <table class="basic-table">
                    <thead>
                        <tr>
                            <th>Team</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let category of filteredCategories">
                            <td>{{ category }}</td>
                            <td>
                                <span *ngIf="currentAssignedCategory === category"
                                    class="assigned-label">Assigned</span>
                                <button *ngIf="currentAssignedCategory !== category" class="btn-red btn-assign-deactive"
                                    (click)="assignCategory(category)">
                                    Assign
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </mat-dialog-content>

    <!-- <mat-dialog-actions class="dialog-actions">
        <button class="btn-white btn-dialog-cancel" (click)="onCancel()">Cancel</button>
        <button class="btn-red" (click)="onAssign()"
            [disabled]="!assignForm.controls.assignee.value?.trim() || isSubmitting">Confirm Assignment</button>
    </mat-dialog-actions> -->
    <!-- <div class="dialog-header">
        <h2>Assign Ticket To</h2>
        <button class="close-btn" (click)="onCancel()">
            <img src="../../../../assets/images/close-icon.svg" alt="Close" />
        </button>
    </div> -->

    <!-- <div class="dialog-body">
        <div class="form-group assignee-group">
            <label>Assignee</label>
            <input type="text" [formControl]="assignForm.controls.assignee" placeholder="Search assignee..."
                autocomplete="off" />
            <div class="user-dropdown"
                *ngIf="showDropdown && filteredUsers.length > 0 && assignForm.controls.assignee.value">
                <div class="user-item" *ngFor="let user of filteredUsers" (click)="selectUser(user)">
                    <span class="user-name">{{ user.name || user.first_name || user.given_name }}</span>
                    <span class="user-email" *ngIf="user.email">{{ user.email }}</span>
                </div>
            </div>
            <div class="loading-text" *ngIf="isLoading">Loading users...</div>
        </div>
        <div class="form-group">
            <label>ETA</label>
            <input type="date" [formControl]="assignForm.controls.eta" />
        </div>
        <div class="form-group">
            <label>Dev Team</label>
            <input type="text" [formControl]="assignForm.controls.devTeam" placeholder="Enter dev team" />
        </div>
    </div> -->

</div>